import React from "react";
import { Form } from "react-bootstrap";

function HotelRegistration_step_5({ register, errors, setValue }) {
  return (
    <>
      <h5 className="step-heading">E. Internship Supervisor</h5>
      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                placeholder="First Name"
                {...register("first_name", {
                  required: "First Name is required",
                  maxLength: {
                    value: 100,
                    message: "First Name cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.first_name && (
                <Form.Text className="text-danger">
                  {errors?.first_name?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                placeholder="Last Name"
                {...register("last_name", {
                  required: "Last Name is required",
                  maxLength: {
                    value: 100,
                    message: "Last Name cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.last_name && (
                <Form.Text className="text-danger">
                  {errors?.last_name?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Job title at the establishment</Form.Label>
              <Form.Control
                placeholder="Job title at the establishment"
                {...register("job_title", {
                  required: "Job title at the establishment is required",
                  maxLength: {
                    value: 100,
                    message:
                      "Job title at the establishment cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.job_title && (
                <Form.Text className="text-danger">
                  {errors?.job_title?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Professional Email</Form.Label>
              <Form.Control
                placeholder="Professional Email"
                {...register("prof_email", {
                  required: "Professional Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors?.prof_email && (
                <Form.Text className="text-danger">
                  {errors?.prof_email?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Mobile Number (OTP)</Form.Label>
              <Form.Control
                placeholder="Mobile Number"
                maxLength={10}
                {...register("prof_contact_no", {
                  required: "Mobile Phone Number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Please enter a valid 10-digit phone number",
                  },
                })}
                isInvalid={!!errors?.prof_contact_no}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.prof_contact_no?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Check
              label="Authorized to sign on behalf of the company"
              {...register("authorized_signatory", {
                required: "Authorization is required",
              })}
            />

            {errors?.authorized_signatory && (
              <Form.Text className="text-danger">
                {errors.authorized_signatory.message}
              </Form.Text>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default HotelRegistration_step_5;
